import { render, staticRenderFns } from "./ValentinesDay_defaultSection.vue?vue&type=template&id=0ecb5313&scoped=true"
import script from "./ValentinesDay_defaultSection.vue?vue&type=script&lang=ts"
export * from "./ValentinesDay_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./ValentinesDay_defaultSection.vue?vue&type=style&index=0&id=0ecb5313&prod&scoped=true&lang=css"
import style1 from "./ValentinesDay_defaultSection.vue?vue&type=style&index=1&id=0ecb5313&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb5313",
  null
  
)

export default component.exports